const BADGE_TIPO = {
    Usuario:      { bg: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)",  color: "var(--azul-bootstrap-cta)" },
    Soporte:      { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)" },
    Moderador:    { bg: "rgba(var(--violeta-bootstrap-rgb), 0.1)",  color: "var(--violeta-bootstrap)" },
    Contador:     { bg: "rgba(var(--amarillo-warning-rgb), 0.15)",  color: "var(--dorado)" },
    Administrador:{ bg: "rgba(var(--naranja-mapa-rgb), 0.1)",  color: "var(--naranja-mapa)" },
    SuperAdmin:   { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)" },
};

function formatearFecha(fecha) {
    if (!fecha) return "—";
    return new Date(fecha).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" });
}

function ListaUsuarios({ usuarios, onVer, labelBoton = "Ver usuario" }) {
    if (!usuarios || !usuarios.length) return null;
    return (
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            {usuarios.map((u, i) => {
                const estilo         = BADGE_TIPO[u.tipo] || BADGE_TIPO.Usuario;
                const nombreCompleto = [u.nombre, u.apellido].filter(v => v && v !== "NA").join(" ") || "Sin nombre";
                const esUltimo       = i === usuarios.length - 1;
                return (
                    <div
                        key={u._id || u.idUsuario}
                        className={`d-flex align-items-center gap-3 px-4 py-3 ${!esUltimo ? "border-bottom" : ""}`}
                        style={{ transition: "background 0.12s" }}
                        onMouseEnter={e => e.currentTarget.style.background = "var(--color-track-bg)"}
                        onMouseLeave={e => e.currentTarget.style.background = ""}
                    >
                        <img
                            src={u.avatar || "/imagenes/marca/avatar.png"}
                            alt={nombreCompleto}
                            className="rounded-circle flex-shrink-0"
                            style={{ width: 40, height: 40, objectFit: "cover" }}
                        />

                        <div className="flex-grow-1 min-w-0">
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <span className="fw-semibold text-dark" style={{ fontSize: "0.9rem" }}>{nombreCompleto}</span>
                                <span className="badge rounded-pill px-2 py-1" style={{ background: estilo.bg, color: estilo.color, fontSize: "0.68rem" }}>
                                    {u.tipo || "Usuario"}
                                </span>
                            </div>
                            <div className="text-muted d-flex flex-wrap gap-3" style={{ fontSize: "0.78rem" }}>
                                <span><i className="bi bi-at me-1"></i>{u.username || "—"}</span>
                                <span><i className="bi bi-envelope me-1"></i>{u.email || "—"}</span>
                                {u.telefono && u.telefono !== "NA" && <span><i className="bi bi-telephone me-1"></i>{u.telefono}</span>}
                                <span className="d-none d-sm-inline"><i className="bi bi-calendar3 me-1"></i>{formatearFecha(u.createdAt)}</span>
                            </div>
                        </div>

                        <button
                            className="btn btn-outline-dark btn-sm rounded-3 flex-shrink-0"
                            onClick={() => onVer(u)}
                        >
                            {labelBoton}
                        </button>
                    </div>
                );
            })}
        </div>
    );
}

export default ListaUsuarios;
